import { A } from "@solidjs/router";
import { padId } from "~/lib";

export const Certificate = props => {
	if ( typeof props.certificate == 'undefined' ) return <span class="px-2 py-1 mr-2 my-1 text-lg font-medium text-gray-600">-</span>;
	
	const stage = props.full ? 'Stage ' : 'S';
	const amendment = props.full ? 'Amendment ' : 'A';

	const stageCount = props.certificate?.meta?.stages?.length ?? 0;
	const amendCount = props.certificate?.meta?.amendments?.length ?? 0;

	let link = props.certificate?.riasId ? padId( props.certificate?.riasId ) : '';

	if ( stageCount ) link += `-Stage${stageCount}`;

	if ( amendCount ) link += `-Amendment${amendCount}`;

	return (
		<A href={`/certificate/C${link}`} target="_blank">
			<span class="inline-flex items-center gap-x-1.5 rounded-md bg-gray-100 px-2 py-1 mr-2 my-1 text-lg font-medium text-gray-600 " classList={{"fill-red-400": props.certificate?.status !='paid',"fill-green-400": props.certificate?.status =='paid'}}>
				<svg viewBox="0 0 6 6" aria-hidden="true" class="size-3.5 ">
					<circle r="3" cx="3" cy="3" />
				</svg>
				C{padId( props.certificate?.riasId )}{stageCount ? ` - ${stage}${stageCount}` : ''}{amendCount ? ` - ${amendment}${amendCount}` : ''}
			</span>
		</A>
	);
}